export { default as MaterialsFavoriteButtonFilter } from './MaterialsFavoriteButtonFilter';
